import React, { useState } from 'react'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { getItem, setItem } from '../../config/localStorage';

function InterestsModal(props) {

    const getInterestsData = getItem('interestsData') ? JSON.parse(getItem('interestsData')) : '';

    const [interests, setInterests] = useState(getInterestsData ? getInterestsData : ['']);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleAddField = () => {
        const newInterests = [...interests, ''];
        setInterests(newInterests);
        setSuccess('')
        setError('')
    };

    const handleRemoveField = (index) => {
        const newInterests = [...interests];
        newInterests.splice(index, 1);
        setInterests(newInterests);
        setSuccess('')
        setError('')
    };

    const handleChange = (index, e) => {
        e.preventDefault()
        const newInterests = [...interests];
        newInterests[index] = e.target.value;
        setInterests(newInterests);
        setSuccess('')
        setError('')
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newInterests = [...interests];
        let isValid = newInterests.every((each) => each !== "");

        const InterestsTitles = newInterests.map(item => item?.trim());
        const uniqueInterestsTitles = new Set(InterestsTitles);
        const hasDuplicateInterestsTitle = InterestsTitles.length !== uniqueInterestsTitles.size;

        if (!isValid) {
            setSuccess('')
            setError('Fields are required!');
        } else if (hasDuplicateInterestsTitle) {
            setError('Oops! It looks like some of the input values are the same!');
        } else {
            setError('');
            setSuccess('Thank you for providing your interest details');
            setItem('interestsData', JSON.stringify(interests));
        }
    };

    const closePopUp = () => {
        setSuccess('')
        setError('')
    };


    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Interests
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {
                            interests.map((field, index) => (
                                <Row key={index} className="mb-3">

                                    <Col md={{ span: 5, offset: 3 } } className={interests.length === 1 ? 'col-12' : 'col-10'}>
                                        <Form.Group >
                                            <Form.Control
                                                type="text"
                                                name="interestsName"
                                                placeholder='Area of experties'
                                                value={field}
                                                onChange={(event) => handleChange(index, event)}

                                            />
                                        </Form.Group>
                                    </Col>
                                    
                                    {
                                        interests.length > 1 && (
                                            <Col md={1}  className='col-2'>
                                                <Button className='btn btn-danger' onClick={() => handleRemoveField(index)}><i className="fa fa-trash"></i></Button>
                                            </Col>
                                        )
                                    }

                                </Row>

                            ))
                        }

                        <Col md={{ span: 5, offset: 3 }} className='text-end mb-3'>
                            <Button className="text-end text-success btn finalize-btn" onClick={handleAddField} ><i className='fa fa-plus'></i> Add one more</Button>
                        </Col>

                        {
                            error ? <div className="alert alert-danger mt-3" role="alert">{error}</div> : ''
                        }

                        {
                            success ? <div className="alert alert-success mt-3" role="alert">{success}</div> : ''
                        }

                        <Modal.Footer>
                            <Button className='button-green' type="submit" onClick={handleSubmit}>Save changes</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default InterestsModal
